
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/detail/[id]",
      function () {
        return require("private-next-pages/content/detail/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/detail/[id]"])
      });
    }
  